import { notifications } from '@mantine/notifications'
import { useQueryClient } from '@tanstack/react-query'

import {
  useBudgetServiceBudgetControllerDeleteBudget,
  useBudgetServiceBudgetControllerGetAllBudgetsKey,
} from '@/__generated__/queries'

import { INSIGHTS_QUERY_KEY } from '@/hooks/useInsightsQuery.hook'

const INVALIDATE_KEYS = [
  useBudgetServiceBudgetControllerGetAllBudgetsKey,
  INSIGHTS_QUERY_KEY,
]

export function useBudgetItemDelete(budgetId: string | null) {
  const queryClient = useQueryClient()

  const deleteMutation = useBudgetServiceBudgetControllerDeleteBudget({
    onSuccess: () => {
      notifications.show({
        color: 'green',
        message: 'Budget has been successfully deleted',
        title: 'Budget deleted',
      })

      INVALIDATE_KEYS.forEach(item => {
        queryClient.invalidateQueries({
          queryKey: [item],
        })
      })
    },
  })

  return {
    deleteBudget: () =>
      deleteMutation.mutate({ budgetId: budgetId ? +budgetId : 0 }),
  }
}
